import type { ContextId } from '../../store/slices/helpSlice';

export type OnboardingStepStatus = 'pending' | 'completed';

export interface OnboardingStep {
  id: string;
  contextId: ContextId;
}

export const ONBOARDING_STEPS: OnboardingStep[] = [
  { id: 'configure_filters', contextId: 'screening' },
  { id: 'run_first_screen', contextId: 'screening' },
  { id: 'open_chart', contextId: 'charts' },
  { id: 'save_favorite', contextId: 'favorites' },
  { id: 'create_alert_optional', contextId: 'alerts' },
];

export const getInitialOnboardingProgress = (): Record<string, OnboardingStepStatus> =>
  ONBOARDING_STEPS.reduce<Record<string, OnboardingStepStatus>>((acc, step) => {
    acc[step.id] = 'pending';
    return acc;
  }, {});
